import { LAYOUTS, } from '@voltmoney/types';
import { HeaderTypeTokens, StepperTypeTokens, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../../routes';
import SharedPropsService from '../../../../SharedPropsService';
import { ACTION } from './types';
import { GoBackAction, ToggleKYCSummaryCTA, navigateCoBorrowerPan, verifyKycSummary, navigateToKYC } from './actions';
import { horizontalStepperRepo } from '../../../../configs/utils';
import { api } from '../../../../configs/api';
import { getAppHeader } from '../../../../configs/config';
import AsyncStorage from "@react-native-async-storage/async-storage";
export const template = (stepper, height, coBorrowerList, enableCTA) => ({
    layout: {
        id: ROUTE.CO_BORROWER_SUMMARY,
        type: LAYOUTS.LIST,
        widgets: [
            { id: "coBorrowerKycSummaryPage", type: WIDGET.CO_BORROWER_KYC_SUMMARY_PAGE }
        ],
    },
    datastore: {
        coBorrowerKycSummaryPage: {
            type: HeaderTypeTokens.verification,
            stepperProps: {
                type: StepperTypeTokens.HORIZONTAL,
                data: stepper,
            },
            headerTitle: 'Joint holder details',
            backAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.CO_BORROWER_SUMMARY,
                payload: {},
            },
            height,
            coBorrowerList,
            nextAction: {
                type: ACTION.NAVIGATION_NEXT,
                routeId: ROUTE.CO_BORROWER_SUMMARY,
                payload: {},
            },
            addCoBorrower: {
                type: ACTION.NAVIGATION_CO_BORROWER_PAN,
                routeId: ROUTE.CO_BORROWER_SUMMARY,
                payload: {},
            },
            retryKYCAction: {
                type: ACTION.NAVIGATE_TO_KYC,
                routeId: ROUTE.CO_BORROWER_SUMMARY,
                payload: {},
            },
            allReKYCsDone: enableCTA
        },
    },
});
export const coBorrowerKYCSummaryMf = {
    onLoad: async ({ network, getHeight }, { coBorrowerId }) => {
        let applicationId;
        const user = await SharedPropsService.getUser();
        if (await AsyncStorage.getItem("application_id") !== null) {
            applicationId = await AsyncStorage.getItem("application_id");
        }
        else {
            applicationId = user.linkedApplications[0].applicationId;
        }
        const coBorrowerInitV2Response = await network.get(`${api.coBorrowerInitV2}${applicationId}`, { headers: await getAppHeader()
        });
        const coBorrowerList = coBorrowerInitV2Response?.data?.stepResponseObject;
        const enableCTA = coBorrowerList.every(item => !(item.reKYCNeeded));
        const stepper = await horizontalStepperRepo(network);
        return Promise.resolve(template(stepper, getHeight(), coBorrowerList, enableCTA));
    },
    actions: {
        [ACTION.GO_BACK]: GoBackAction,
        [ACTION.NAVIGATION_CO_BORROWER_PAN]: navigateCoBorrowerPan,
        [ACTION.NAVIGATION_NEXT]: verifyKycSummary,
        [ACTION.TOGGLE_CTA]: ToggleKYCSummaryCTA,
        [ACTION.NAVIGATE_TO_KYC]: navigateToKYC,
    },
};
